import { createIcon } from '@chakra-ui/icons';

export const Logout = createIcon({
  displayName: 'Logout',
  viewBox: '0 0 18 18',
  path: [
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_554_3142)">
        <path
          d="M7.5376 5.5875V3.15C7.5376 2.76212 7.69168 2.39013 7.96595 2.11586C8.24023 1.84158 8.61222 1.6875 9.0001 1.6875H14.8501C15.238 1.6875 15.61 1.84158 15.8842 2.11586C16.1585 2.39013 16.3126 2.76212 16.3126 3.15V14.85C16.3126 15.2379 16.1585 15.6099 15.8842 15.8841C15.61 16.1584 15.238 16.3125 14.8501 16.3125H9.0001C8.61222 16.3125 8.24023 16.1584 7.96595 15.8841C7.69168 15.6099 7.5376 15.2379 7.5376 14.85V12.4125"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4125 9H1.6875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6125 6.07544L1.6875 9.00044L4.6125 11.9254"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_3142">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
